// JS pack used only by app/views/layouts/events.html.erb.
// CSS lives in events.scss as a sibling pack so it gets a dedicated entry
// in the webpacker manifest (stylesheet_pack_tag 'events' resolves it).
// @rails/ujs 7 は default export なので require(...).start() では落ちる。ESM import で受ける。
import Rails from "@rails/ujs"
import * as ActiveStorage from "@rails/activestorage"
import "bootstrap5/dist/js/bootstrap.bundle"

Rails.start()
ActiveStorage.start()
